import {EVENT_COMMENT_OWN_PRODUCT} from './comment-own-product.js';
import {EVENT_PUBLISH} from './publish.js';
import {EVENT_OFFER_RESPONSE} from './offer-response.js';

const EVENT_SELLING_INTENTION = 'event-selling-intention';

const sellingIntentionEventTrigger = () => {
	document.addEventListener(EVENT_COMMENT_OWN_PRODUCT, () =>
      sellingIntentionEventDispatch());
  document.addEventListener(EVENT_PUBLISH, () =>
      sellingIntentionEventDispatch());
  document.addEventListener(EVENT_OFFER_RESPONSE, () =>
      sellingIntentionEventDispatch());
};

const sellingIntentionEventDispatch = () => {
	const event = new CustomEvent(EVENT_SELLING_INTENTION);
	document.dispatchEvent(event);
}

export {EVENT_SELLING_INTENTION, sellingIntentionEventTrigger};